import { Form } from "antd";
import { CustomButton } from "@Components/Button";
import FormItem from "@Components/FormItem/FormItem";
import ArrowRight from "@Assets/icons/arrow-right.svg";
import UnAuthHeader from "../UnAuthHeader";
import Lock from "@Assets/icons/lock.svg";
import useResetPasswordContainer from "./useResetPasswordContainer";

const ResetPassword = () => {
  const { form, handleSubmit, handleLogin, isResettingPassword } = useResetPasswordContainer();

  return (
    <div className="flex justify-center items-center w-full px-4 sm:px-6 md:px-8 py-4 sm:py-6 md:py-8">
      <div className="py-4 sm:py-6 px-6 bg-white w-full max-w-[360px] sm:max-w-[400px] 2xl:max-w-[448px] min-h-[350px] 2xl:min-h-[420px] rounded-[18px] shadow-md  ">
        <UnAuthHeader headerTitle="Reset Password" subTitle="" />

        <div className="px-2 !mb-4 pt-2 ">
          <Form
            form={form}
            onFinish={handleSubmit}
            className="py-2"
          >
            <FormItem
              name="password"
              label="New Password"
              rules={[
                { required: true, message: "Please Enter your password!" },
                { min: 8, message: "Password must be at least 8 characters" },
              ]}
              inputConfig={{
                label: "New Password",
                isPassword: true,
                placeholder: "Enter your password",
                leftIcon: <Lock />,
              }}
            />
            <FormItem
              name="confirmPassword"
              label="Confirm New Password"
              rules={[
                {
                  required: true,
                  message: "Please Enter your confirm password!",
                },
                // { min: 8, message: "Password must be at least 8 characters" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Passwords do not match!"));
                  },
                }),
              ]}
              inputConfig={{
                label: "Confirm New Password",
                isPassword: true,
                placeholder: "Enter your password",
                leftIcon: <Lock />,
              }}
            />
            <Form.Item className="text-center max-w-full !pt-2">
              <CustomButton
                title={"Update"}
                shape="round"
                btnColor="danger"
                type="primary"
                iconPosition="right"
                icon={<ArrowRight />}
                className="w-full h-[44px] sm:h-[50px] font-bold tracking-[1%] !rounded-[12px] text-sm sm:text-base"
                htmlType="submit"
                isLoading={isResettingPassword}
                disabled={isResettingPassword}
              />
            </Form.Item>
            <div className="text-center">
              <p className="text-[#575757] text-[14px] sm:text-[14px] font-[500]">
                Back to{" "}
                <span
                  className="text-[#111827] font-[500] cursor-pointer"
                  onClick={handleLogin}
                >
                  Login
                </span>
              </p>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
